import { styled } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
const PREFIX = 'DateTimePicker'

export const classes = {
  dateTimePicker: `${PREFIX}-dateTimePicker`,
  mobileDateTimePicker: `${PREFIX}-mobileDateTimePicker`,
  timePicker: `${PREFIX}-timePicker`,
  datePicker: `${PREFIX}-datePicker`,
  clearIcon: `${PREFIX}-clearIcon`,
}

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.dateTimePicker}`]: {
    margin: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },

  [`& .${classes.mobileDateTimePicker}`]: {
    margin: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.timePicker}`]: {
    display: 'flex',
    flexDirection: 'row',
  },

  [`& .${classes.datePicker}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.clearIcon}`]: {
    marginTop: theme.spacing(2.5),
    cursor: 'pointer',
  },
}))

export default StyledFormControl
